import Vue from 'vue';
import Router from 'vue-router';
import LoginView from './views/LoginView.vue';
import RedirectToTenantStartView from '@/views/RedirectToTenantStartView';

// Admin views
import UserManagementView from './views/UserManagementView.vue';
import Tenants from './views/TenantsView.vue';
import TranslationsView from '@/views/main/TranslationsView';
import CreateSurveyTemplateView from '@/views/main/CreateSurveyTemplateView';
import TasksManagementView from '@/views/main/TasksManagementView';

// User views
import UserProfile from './views/UserProfile.vue';

// Tenant views
import TenantContainer from './views/TenantContainer.vue';
import TenantUserManagementView from './views/tenant/TenantUserManagementView.vue';
import TenantManagementView from './views/tenant/TenantManagementView.vue';
import WorkTasksView from '@/views/tenant/WorkTaskView';

import SurveysView from '@/views/tenant/SurveysView.vue';
import CreateSurveyView from '@/views/tenant/CreateSurveyView.vue';
import SurveyCreatedView from '@/views/tenant/SurveyCreatedView.vue';
import SingleSurveyView from '@/views/tenant/SingleSurveyView';

import PartiesView from '@/views/tenant/PartiesView';
import PartyView from '@/views/tenant/PartyView';

import PersonsView from '@/views/tenant/PersonsView';
import PersonView from '@/views/tenant/PersonView';
import ItemsView from '@/views/tenant/ItemsView';
import SurveyTemplatesView from '@/views/main/SurveyTemplatesView';
import EditSurveyTemplateView from '@/views/main/EditSurveyTemplateView';
import CategoriesView from '@/views/main/CategoriesView';
import OnboardingView from '@/views/tenant/OnboardingView';
import SimpleOnboardingView from "@/views/tenant/SimpleOnboardingView";

import DashboardView from '@/views/tenant/DashboardView';
import ReportsView from '@/views/tenant/ReportsView';
import ReportCategoryView from '@/views/tenant/ReportCategoryView';
import TasksView from '@/views/tenant/TasksView';
import FinancialsView from '@/views/tenant/FinancialsView';
import NewAccountView from '@/views/NewAccountView';
import Logout from '@/views/tenant/Logout';

import AccessDeniedView from '@/views/AccessDeniedView';
import PageNotFound from '@/views/PageNotFound';
import AdminMessageCenterView from "@/views/main/AdminMessageCenterView.vue";
import EditMessageCenterView from "@/views/main/EditMessageCenterView.vue";
import MessagesView from "@/views/tenant/MessagesView.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: LoginView,
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
        },
        {
            path: '/',
            name: 'start',
            component: RedirectToTenantStartView,
            meta: {hideMenu: true},
        },
        {
            path: '/new_account',
            name: 'new_account',
            component: NewAccountView,
        },
        {
            path: '/users',
            name: 'users',
            component: UserManagementView,
        },
        {
            path: '/me',
            name: 'userprofile',
            component: UserProfile,
        },
        {
            path: '/access_denied',
            name: 'access_denied',
            component: AccessDeniedView,
        },
        {
            path: '/t/:tenantId',
            props: true,
            component: TenantContainer,
            children: [
                {
                    path: 'deprecated_onboarding/:step?',
                    name: 'tenant_deprecated_onboarding',
                    component: OnboardingView,
                    props: true,
                },
                {
                    path: 'onboarding',
                    name: 'tenant_onboarding',
                    component: SimpleOnboardingView,
                    meta: {hideMenu: true},
                },
                {
                    path: 'dashboard',
                    name: 'tenant_start',
                    component: DashboardView,
                    props: true
                },
                {
                    path: 'tasks',
                    name: 'tenant_tasks',
                    component: TasksView,
                },
                {
                    path: 'reports',
                    name: 'tenant_reports',
                    component: ReportsView,
                },
                {
                    path: 'reports/rg/:category/:subcategory?',
                    name: 'tenant_report_category',
                    component: ReportCategoryView,
                },

                {
                    path: 'analyses',
                    name: 'tenant_surveys',
                    component: SurveysView,
                },

                {
                    path: 'analyses/new',
                    name: 'tenant_create_survey',
                    component: CreateSurveyView,
                },
                {
                    path: 'analyses/created/:id',
                    name: 'tenant_survey_created',
                    props: true,
                    component: SurveyCreatedView,
                },
                {
                    path: 'analyses/s/:id',
                    name: 'tenant_single_survey',
                    props: true,
                    component: SingleSurveyView,
                },
                {
                    path: 'users',
                    name: 'tenant_users',
                    props: true,
                    component: TenantUserManagementView,
                },
                {
                    path: 'settings',
                    name: 'tenant_settings',
                    props: true,
                    component: TenantManagementView,
                },
                {
                    path: 'messages',
                    name: 'tenant_messages',
                    component: MessagesView,
                },
                {
                    path: 'persons',
                    name: 'tenant_persons',
                    component: PersonsView,
                },
                {
                    path: 'person',
                    name: 'tenant_new_person',
                    props: true,
                    component: PersonView,
                },
                {
                    path: 'person/:id',
                    name: 'tenant_person',
                    props: true,
                    component: PersonView,
                },
                {
                    path: 'parties',
                    name: 'tenant_parties',
                    component: PartiesView,
                },
                {
                    path: 'party',
                    name: 'tenant_new_party',
                    props: true,
                    component: PartyView,
                },
                {
                    path: 'party/:id/:tab?',
                    name: 'tenant_party',
                    props: true,
                    component: PartyView,
                },
                {
                    path: 'items',
                    name: 'tenant_items',
                    component: ItemsView,
                },
                {
                    path: 'worktasks',
                    name: 'tenant_work_tasks_view',
                    component: WorkTasksView,
                },
                {
                    path: 'financials',
                    name: 'tenant_financials',
                    component: FinancialsView,
                },
            ],
        },
        {
            path: '/tenants',
            name: 'tenants',
            component: Tenants,
        },

        {
            path: '/adminmessagecenter',
            name: 'adminmessagecenter',
            component: AdminMessageCenterView,
        },
        {
            path: '/adminmessagecenter/message/new',
            name: 'create_messagecenter_message',
            component: EditMessageCenterView,
        },
        {
            path: '/adminmessagecenter/message/:id',
            name: 'edit_messagecenter_message',
            component: EditMessageCenterView,
        },

        {
            path: '/translations',
            name: 'translations',
            component: TranslationsView,
        },
        {
            path: '/surveytemplates/new',
            name: 'create_survey_template',
            component: CreateSurveyTemplateView,
        },
        {
            path: '/surveytemplates/:key',
            name: 'edit_survey_template',
            component: EditSurveyTemplateView,
        },
        {
            path: '/surveytemplates',
            name: 'survey_templates',
            component: SurveyTemplatesView,
        },
        {
            path: '/categories',
            name: 'categories',
            component: CategoriesView,
        },
        {
            path: '/tasksmanagement',
            name: 'tasks_management',
            component: TasksManagementView,
        },
        {
            path: '*',
            name: 'page_not_found',
            component: PageNotFound,
        },
    ],
});
